module.exports = __webpack_public_path__ + "static/media/LoginBg.2ccfb2c8.jpg";